/* eslint eqeqeq: 0 */
import { Record } from "immutable";
import moment from "moment";

const StatRecord = new Record({
  date: undefined,

  clicks: 0,
  shows: 0,
  ko: 0,
  ctr: 0,
  spent: 0,
  cpc: 0,
  rpm: 0,
  revenue: 0,

  vshows: 0,
  vctr: 0,
  vrpm: 0,
  vshows_percent: 0,

  a_block_ctr: 0,
  incoming: 0,
  outcoming: 0,
  k_ko: 0,

  s_cid_block_shows: 0,
  s_cid_ad_shows: 0,
  a_teaser_cid_ctr: 0,
  a_cpc: 0,
  a_cpm: 0,
  s_money_in: 0,
  s_money_out: 0,
  shows_in_top: 0,
  shows_in_inf: 0,
  s_cid_shows: 0,

  profit_new: 0,
  profit_other: 0,
  system_profit_new: 0,
  system_profit_other: 0
});

export default class Stat extends StatRecord {
  isWeekEnd() {
    const day = moment(this.date).day();

    if (day == 0 || day == 6) {
      return true;
    }

    return false;
  }
}
